import {
  GUIDELINES_PLACEMENT_ABOVE_SLOTS,
  GUIDELINES_PLACEMENT_BEFORE_BOOKING,
  GuidelinesPlacement,
} from 'configs/siteAndTrustAttributes';

export const GUIDELINES_SELECTION_NONE = 'none';

export type GuidelinesSelection =
  | typeof GUIDELINES_SELECTION_NONE
  | GuidelinesPlacement;

export const GUIDELINES_SELECTIONS = [
  GUIDELINES_SELECTION_NONE,
  GUIDELINES_PLACEMENT_BEFORE_BOOKING,
  GUIDELINES_PLACEMENT_ABOVE_SLOTS,
] as const;

export const guidelinesSelectionLabelKeys: {
  [key in GuidelinesSelection]: string;
} = {
  [GUIDELINES_SELECTION_NONE]: 'guidelines-placement-none',
  [GUIDELINES_PLACEMENT_BEFORE_BOOKING]: 'guidelines-placement-before-booking',
  [GUIDELINES_PLACEMENT_ABOVE_SLOTS]: 'guidelines-placement-above-slots',
};
